// Ported from twifi-theme-html/src/scripts/helpers/countdown.js
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function parseDuration(iso) {
    const match = /^P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/.exec(iso || '');

    if (!match) return 0;

    const [, days, hours, minutes, seconds] = match;

    return (
        (Number(days) || 0) * DAY +
        (Number(hours) || 0) * HOUR +
        (Number(minutes) || 0) * MINUTE +
        (Number(seconds) || 0) * SECOND
    );
}

function getTargetTimestamp(el) {
    const end = el.getAttribute('data-countdown-end');

    if (end) return new Date(end).getTime();

    return Date.now() + parseDuration(el.getAttribute('data-countdown-duration'));
}

function pad(n) {
    return String(Math.max(n, 0)).padStart(2, '0');
}

function tick(el, target) {
    const remaining = Math.max(target - Date.now(), 0);
    const units = {
        days: Math.floor(remaining / DAY),
        hours: Math.floor((remaining % DAY) / HOUR),
        minutes: Math.floor((remaining % HOUR) / MINUTE),
        seconds: Math.floor((remaining % MINUTE) / SECOND),
    };

    Object.keys(units).forEach((unit) => {
        const unitEl = el.querySelector(`[data-countdown-unit="${unit}"]`);

        if (unitEl) unitEl.textContent = pad(units[unit]);
    });

    return remaining <= 0;
}

function initCountdown(el) {
    const target = getTargetTimestamp(el);

    if (!target || Number.isNaN(target) || tick(el, target)) return;

    const interval = setInterval(() => {
        if (tick(el, target)) clearInterval(interval);
    }, SECOND);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-countdown-duration], [data-countdown-end]').forEach(initCountdown);
});
